import React, { FC, ReactNode, useState } from 'react';
import { KitchenExcessReturnContext, KitchenExcessReturnsType } from './context';

const KitchenExcessReturnProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [excessReturnToUpdate, setExcessReturnToUpdate] = useState<KitchenExcessReturnsType | any>(
    null
  );
  return (
    <KitchenExcessReturnContext.Provider
      value={{
        excessReturnToUpdate,
        setExcessReturnToUpdate
      }}>
      {children}
    </KitchenExcessReturnContext.Provider>
  );
};

export default KitchenExcessReturnProvider;
